/**
 * EM 实体类通用ListView mixin
 *   提供常用组件的注册，路由状态，默认modelName
 *   以及routeHelper和commonModal的混入
 *
 * Author YuJiaBei
 * Date 2020-07-12 08:14:36
 */
import EmViewTitle from "@/components/em/EmViewTitle";
import EmFilter from "@/components/em/EmFilter";
import EmTable from "@/components/em/EmTable";
import EmButton from "@/components/em/EmButton";
import emRouteHelperMixin from "@/mixin/em/helper/route";
import emCommonModalMixin from "@/mixin/em/common/modal";

export default {
    mixins: [emRouteHelperMixin, emCommonModalMixin],
    components: {EmViewTitle, EmFilter, EmTable, EmButton},
    computed: {
        /**
         * 路由状态
         * default：edit
         * @returns {*}
         */
        $_emCommonListMixin_pathType() {
            return this.$_emRouterHelperMixin_pathType ? this.$_emRouterHelperMixin_pathType : 'edit'
        },
        /**
         * 默认的modelName，因为mixin的合并规则可以允许覆写，这里就不采用$_命名规范了
         * @returns {default.computed.$_emRouterHelperMixin_entityName}
         */
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emCommonListMixin_needToRefresh: {
            get() {
                return this.$store.state[this.modelName] !== undefined && this.$store.state[this.modelName].needToRefresh;
            },
            set(value) {
                this.$store.commit(`${this.modelName}/setNeedToRefresh`, value)
            }
        },
        /**
         * 新消息
         * @returns {null}
         */
        $_emCommonListMixin_newNotification() {
            return this.$store.state["emMenu"].newNotification
        }
    },
    watch: {
        $_emCommonListMixin_needToRefresh(newValue, oldValue) {
            newValue && this.$refs["emListFilter"] && this.$refs["emListFilter"].doQuery()
        }
    },
    mounted() {
        // this.$store.dispatch("emBase/emBaseQueryByFilter", {entity: this.modelName})
        (this.$_emCommonListMixin_needToRefresh || this.$route.params.needRefresh) && this.$refs["emListFilter"] && this.$refs["emListFilter"].doQuery();
    }
};
